module.exports = __webpack_public_path__ + "img/emo.507dbd05.png";